module.exports = __webpack_public_path__ + "static/media/CircleOff.24b42712.svg";